app.controller("DocumentTypesController", [
    "$scope", "$uibModal", "SysParam", "StaticData", "ConfirmModal", "$stateParams", "usSpinnerService", "$state", "toastr", "DocumentsService",
    function ($scope, $uibModal, SysParam, StaticData, ConfirmModal, $stateParams, usSpinnerService, $state, toastr, DocumentsService) {

        $scope.documentType = null;
        $scope.documentTypes = [];
        $scope.types = [];

        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.documentType = $stateParams.type;

        StaticData.getItemsByKey("document_basic_types").then(function (types) {
            $scope.types = [{ name: "ტიპი" }].concat(types);
            $scope.typesMap = _.keyBy($scope.types, '_id');
        });

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });


        $scope.goToPage = function (page) {
            $state.go(".", { page: page });
        };

        $scope.applyFilter = function () {
            $state.go(".", {
                type: $scope.documentType
            });
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        function loadPage(page, cb) {
            cb = cb || function () {
            };
            usSpinnerService.spin("root");
            DocumentsService.typeList({
                type: $stateParams.type || $scope.documentType,
                admin: true
            }).then(function (data) {
                $scope.documentTypes = data.map(type => {
                    let parentType = '';
                    if (type.parentId == 'INNER' || type.parentId == 'STUDENT_INNER') parentType = 'შიდა'
                    else if (type.parentId == 'OTHER') parentType = 'სხვა'
                    else parentType = 'გარე'
                    type.name = type.name + ' - ' + parentType;
                    return type;
                });
                usSpinnerService.stop("root");
                $scope.totalItems = data.length;
                cb();
            });
        }

        $scope.generateDocTypes = function () {
            usSpinnerService.spin("root");
            DocumentsService.generateDocTypes().then(function (data) {
                $scope.documentTypes = data;
                $scope.totalItems = data.length;
                usSpinnerService.stop("root");
            });
        };

        $scope.add = function () {
            $uibModal.open({
                controller: "DocumentTypesAddAddController",
                templateUrl: _pb + 'employee/parameters/document-type-add.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            action: 'add',
                            docType: null
                        };
                    }
                }
            }).result
                .then(function (result) {
                    toastr.success('', 'დოკუმენტის ტიპი წარმატებით დაემატა');
                    loadPage($stateParams.page);
                }, function () {
                });
        };

        $scope.edit = function (docType) {
            $uibModal.open({
                controller: "DocumentTypesAddAddController",
                templateUrl: _pb + 'employee/parameters/document-type-add.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            action: 'edit',
                            docType: docType
                        };
                    }
                }
            }).result
                .then(function (result) {
                    toastr.success('', 'დოკუმენტის ტიპი წარმატებით დარედაქტირდა');
                    loadPage($stateParams.page);
                }, function () {
                });
        };

        $scope.remove = function (docType) {
            ConfirmModal.show({
                title: "დოკუმენტის ტიპის წაშლა",
                message: "გსურთ '" + docType.name + "' წაშალოთ დოკუმენტის ტიპებიდან?"
            }).result.then(function () {
                usSpinnerService.spin("root");
                DocumentsService.removeDocType(docType._id).then(function (result) {
                    usSpinnerService.stop("root");
                    toastr.success('', 'დოკუმენტის ტიპი წარმატებით წაიშალა');
                    loadPage($stateParams.page);
                }).catch(function (err) {
                    usSpinnerService.stop("root");
                    if (err.status == 400) {
                        toastr.error('', 'დაფიქსირდა შეცდომა!');
                    }
                });
            });
        };
    }
]);
